/*
 * Square card images.
 *
 * A product card frame is square in two different ways: because the section's
 * image_ratio setting says so (snippets/card-product.liquid handles that in
 * Liquid), or because CSS forces --ratio-percent:100% at some breakpoint. The
 * second is invisible to Liquid and the breakpoint differs per section, so the
 * only reliable test is to measure the frame that actually rendered.
 *
 * Where a product has a square image, card-product publishes it on the <img> as
 * data-square-srcset / data-square-src. This measures each frame and picks the
 * source that matches its shape, re-checking on resize so rotating a phone or
 * crossing a breakpoint corrects itself.
 *
 * Only the image source changes — never a width, height or ratio — so this can
 * never move the layout.
 */
(function () {
  var TOLERANCE = 0.02; // a frame within 2% of 1:1 counts as square

  function frameOf(img) {
    return img.closest('.card__inner') || img.closest('.card__media') || img.parentElement;
  }

  function apply(img) {
    var frame = frameOf(img);
    if (!frame) return;
    var r = frame.getBoundingClientRect();
    if (!r.width || !r.height) return;

    // Remember the original source once, so we can go back on resize.
    if (img.dataset.baseSrc === undefined) {
      img.dataset.baseSrcset = img.getAttribute('srcset') || '';
      img.dataset.baseSrc = img.getAttribute('src') || '';
    }

    var square = Math.abs(r.width - r.height) / r.width < TOLERANCE;
    var want = square ? 'square' : 'base';
    if (img.dataset.appliedSource === want) return;
    img.dataset.appliedSource = want;

    if (square) {
      img.setAttribute('srcset', img.dataset.squareSrcset || '');
      img.setAttribute('src', img.dataset.squareSrc || '');
    } else {
      img.setAttribute('srcset', img.dataset.baseSrcset);
      img.setAttribute('src', img.dataset.baseSrc);
    }
  }

  function run() {
    document.querySelectorAll('.card__media img[data-square-src]').forEach(apply);
  }

  function ready() {
    run();
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(run, 150);
    });
    // Cards arrive later in places that render over the Section Rendering API
    // (product recommendations, paginated grids, filters).
    if (window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          run();
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
